"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "component__StyledButton",
  componentId: "sc-1hkaugy-0"
})(["cursor:pointer;font-family:inherit;font-size:16px;color:#393f44;border:1px solid rgba(202,204,208,0.85);background:transparent;padding:10px 20px;border-radius:5px;outline:1;&[disabled]{pointer:default;opacity:0.5;}&[aria-pressed = \"true\"]:not([disabled]){border:1px solid ", ";color:", ";}", " ", " ", " ", ""], function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.size && props.size === "small" && (0, _styledComponents.css)(["padding:7px 15px;"]);
}, function (props) {
  return props.btnType && props.btnType === "cta" && (0, _styledComponents.css)(["background:", ";color:#fff;border:1px solid transparent;"], props.color);
}, function (props) {
  return props.btnType && props.btnType === "highlight" && (0, _styledComponents.css)(["color:", ";border:1px solid ", ";"], props.color, props.color);
}, function (props) {
  return props.btnType && props.btnType === "default" && (0, _styledComponents.css)(["&:hover:not([disabled]){", "}"], function (props) {
    return props.color && (0, _styledComponents.css)(["border:1px solid ", ";color:", ";"], props.color, props.color);
  });
});

var Button = function Button(_ref) {
  var type = _ref.type,
      _ref$btnType = _ref.btnType,
      btnType = _ref$btnType === void 0 ? "default" : _ref$btnType,
      theme = _ref.theme,
      children = _ref.children,
      active = _ref.active,
      props = _objectWithoutProperties(_ref, ["type", "btnType", "theme", "children", "active"]);

  return (
    /*#__PURE__*/
    _react["default"].createElement(StyledButton, _extends({}, props, {
      color: theme.color,
      type: "button",
      role: "button",
      btnType: btnType
    }, typeof active === 'boolean' ? {
      'aria-pressed': active
    } : {}), children)
  );
};

var _default = Button;
exports["default"] = _default;